import { render } from "./PricesOutro.vue?vue&type=template&id=517b4de7&scoped=true"
import script from "./PricesOutro.vue?vue&type=script&lang=js"
export * from "./PricesOutro.vue?vue&type=script&lang=js"

import "./PricesOutro.vue?vue&type=style&index=0&id=517b4de7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-517b4de7"]])

export default __exports__